import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'Lukas',
  city: 'Zermatt'
}, {
  name: 'Simon',
  city: 'St. Moritz'
}, {
  name: 'Marc',
  city: 'Davos'
}, {
  name: 'Thomas',
  city: 'Verbier'
}, {
  name: 'Stefan',
  city: 'Gstaad'
}, {
  name: 'Michael',
  city: 'Arosa'
}, {
  name: 'Andreas',
  city: 'Engelberg'
}, {
  name: 'Reto',
  city: 'Grindelwald'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    // Hide after 6 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next one after 12-20 seconds
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  return <AnimatePresence data-id="element-217">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -50,
      y: 20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: -50,
      scale: 0.9
    }} className="fixed bottom-4 left-4 sm:bottom-8 sm:left-8 z-50 max-w-[300px] w-full" data-id="element-218">
          <div className="bg-white border border-brand-border rounded-xl p-4 shadow-xl relative overflow-hidden group" data-id="element-219">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-navy to-brand-gold" data-id="element-220" />

            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-brand-navy" data-id="element-221">
              <XIcon className="w-4 h-4" data-id="element-222" />
            </button>

            <div className="flex items-center gap-3" data-id="element-223">
              <div className="w-10 h-10 rounded-full bg-brand-navy flex items-center justify-center text-white font-bold text-lg shrink-0" data-id="element-224">
                {currentBuyer.name.charAt(0)}
              </div>
              <div data-id="element-225">
                <p className="text-sm text-brand-text font-medium leading-tight" data-id="element-226">
                  <span className="font-bold text-brand-navy" data-id="element-227">
                    {currentBuyer.name}
                  </span>{' '}
                  aus {currentBuyer.city} hat gerade das System gekauft
                </p>
                <div className="flex items-center gap-2 mt-1" data-id="element-228">
                  <span className="flex items-center gap-1 text-xs text-green-600 font-bold" data-id="element-229">
                    <span className="w-1.5 h-1.5 rounded-full bg-green-600 animate-pulse" data-id="element-230" />
                    Verifiziert
                  </span>
                  <span className="text-xs text-brand-muted" data-id="element-231">
                    vor {timeAgo} Minuten
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}